<template>
    <v-card v-if="timelineItem.id" tile flat class="theme-back d-inline-flex flex-column flex-nowrap outerBox" height="120px" width="100%" :disabled="gamefinished">
        <v-card tile flat
                class="innerBox"
                :class="{'draftEvent': timelineItem.isDraft, 'theme-red-border': !timelineItem.approved && timelineItem.rejectReason, 'theme-green-border': timelineItem.approved}"
                :style="{'background-color': $vuetify.theme.dark ? '#262830' : '#ececec', 'border-color': $vuetify.theme.dark ? '#262830' : '#ececec'}">
            <v-card tile flat v-if="timelineItem.isDraft" class="draftText theme-title">Vázlat</v-card>
            <v-card-title class="d-block theme-title">
                {{ timelineItem.score && timelineItem.score.teamA ? timelineItem.score.teamA : 0 }} - {{timelineItem.score && timelineItem.score.teamB ? timelineItem.score.teamB : 0 }}
            </v-card-title>
            <v-card-subtitle class="d-block theme-title">
                {{ timelineItem.actionName }}
                <v-card-text class="d-block theme-text" v-show="timelineItem.actionType">
                    {{ localConstants.ACTIONS.ACTION_MAPPING[timelineItem.actionType] }}
                </v-card-text>
            </v-card-subtitle>
            <v-card-text class="d-block theme-text">
                {{ timelineItem.jersey }} {{ timelineItem.playerName }}
            </v-card-text>
        </v-card>
        <v-card-actions class="d-block pr-2 theme-title"
                        :class="timelineItem.isDraft ? 'draftBorder ' : ''"
                        :style="{'border-color': $vuetify.theme.dark ? '#262830' : '#ececec'}">
            <div class="bottom-row">
                <div class="period-name">{{ actionCardPeriod }}</div>
                <div class="gametime">{{ timelineItem.gameTime }}</div>
            </div>
        </v-card-actions>
    </v-card>
</template>

<script>
    import CONSTANTS from "../constants";

    export default {
        name: "TimelineCard",
        props: {
            index: Number,
            item: Object,
            gamedata: Object,
            periodItems: Array,
            gamefinished: Boolean

        },
        data() {
            return {
                timelineItem: {},
                localConstants: CONSTANTS,
            }
        },
        methods: {
            refreshData() {
                let player = null;
                let teamName = null;

                if (this.item.params.selectedTeamId === 'teamA') {
                    player = this.gamedata.team_a_players.find(playerObj => playerObj.id === this.item.params.selectedPlayer);
                    teamName = this.gamedata.team_a_name;
                } else if (this.item.params.selectedTeamId === 'teamB') {
                    player = this.gamedata.team_b_players.find(playerObj => playerObj.id === this.item.params.selectedPlayer);
                    teamName = this.gamedata.team_b_name;
                } else if (this.item.params.selectedTeamId === 'staffA') {
                    player = this.gamedata.team_a_officials.find(playerObj => playerObj.id === this.item.params.selectedPlayer);
                    teamName = this.gamedata.team_a_name;
                } else if (this.item.params.selectedTeamId === 'staffB') {
                    player = this.gamedata.team_b_officials.find(playerObj => playerObj.id === this.item.params.selectedPlayer);
                    teamName = this.gamedata.team_b_name;
                }

                let scoreA = (this.item.params && this.item.params.teamScore) ? this.item.params.teamScore.teamA : undefined;
                let scoreB = (this.item.params && this.item.params.teamScore) ? this.item.params.teamScore.teamB : undefined;
                let id = this.item.UUID ? this.item.UUID : this.item.id;

                this.timelineItem = {
                    id: id,
                    jersey: player ? player.jersey : null,
                    playerName: player ? player.name : null,
                    gameTime: this.item.params ? this.item.params.gameTime : null,
                    action: this.item.action,
                    actionName: this.item.params.selectedAction ? this.item.params.selectedAction.actionName : null,
                    actionType: this.item.params ? this.item.params.selectedActionType : null,
                    isDraft: this.item.isDraft,
                    approved: this.item.params.approved,
                    rejectReason: this.item.params.rejectReason,
                    teamName: teamName,
                    score: {
                        "teamA": scoreA,
                        "teamB": scoreB,
                    },
                    period: this.item.period
                }
            }
        },
        created() {
            this.refreshData();
        },
        computed: {
            actionCardPeriod: function () {
                let period = this.periodItems.find(item => item.value === this.item.period);
                if(period === undefined) {
                    period = this.periodItems.find(item => item.value == this.item.period);
                }
                return period ? period.text : '-';
            }
        },
        watch: {
            item: {
                handler: function () {
                    this.refreshData();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .v-card__title {
        padding: 0;
        font-size: 16px;
        font-weight: bold;
        text-align: right;
        height: 16px;
        line-height: 16px;
        margin-top: 0;
        margin-bottom: 4px;
    }

    .v-card__subtitle {
        padding: 0;
        font-size: 12px;
        font-weight: bold;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        text-align: right;
        height: 28px;
        line-height: 14px;
        margin-top: 0 !important;
        margin-bottom: 4px;
        overflow: hidden;
    }

    .v-card__text {
        padding: 0;
        font-size: 12px;
        font-weight: normal;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        text-align: right;
        margin-top: 0;
        margin-bottom: 0;
        height: 14px;
        line-height: 14px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .v-card.draftText {
        position: absolute;
        top: 8px;
        left: 8px;
        font-size: 10px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        font-style: italic;
        line-height: 16px;
        background-color: transparent;
    }

    .v-card__actions {
        padding: 0;
        border-right-style: solid;
        border-right-width: 1px;
        text-align: right;
        line-height: 26px;
        height: 26px;
        font-size: 14px;
        font-weight: bold;
    }

    .v-card.outerBox {
        padding-top: 8px;
        max-width: calc(20% - 19.2px);
        margin-right: 16px;
    }

    .v-card.outerBox:first-child {
        margin-left: 16px;
    }

    .v-card.innerBox {
        border-style: solid;
        border-width: 1px;
        flex: 1 1 auto;
        padding: 8px;
        position: relative;
    }

    .theme--light.v-card.innerBox.draftEvent {
        background-color: #ffffff !important;
    }

    .theme--dark.v-card.innerBox.draftEvent {
        background-color: #40434f !important;
    }

    .theme--light.draftBorder {
        border-color: #ffffff !important;
    }

    .theme--dark.draftBorder {
        border-color: #40434f !important;
    }

    .bottom-row {
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
        width: 100%;
    }

    .period-name {
        display: block;
        white-space: nowrap;
        width: 70%;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
        padding-left: 6px;
    }

    .gametime {
        display: block;
        white-space: nowrap;
        width: 30%;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: right;
    }
</style>
